<template>
  <div id="modalLog" class="modal fade">
    <div class="modal-dialog modal-dialog-vertical-center modal-lg" role="document">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">{{$t("financial.操作日志")}}</h6>
          <button type="button" data-dismiss="modal" aria-label="Close" class="close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25">
        	<table class="table mg-b-0">
            <tbody v-if="type == 1">
              <tr v-for="item in info.reason">
                <td class="valign-middle hidden-xs-down">
                  <div>{{item}}</div>
                </td>
              </tr>
            </tbody>
            <tbody v-if="type == 2">
              <tr v-for="item in info.remark">
                <td class="valign-middle hidden-xs-down">
                  <div>{{item}}</div>
                </td>
              </tr>
            </tbody>
         </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-semibold" data-dismiss="modal">{{$t("financial.取消")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["open","info","type"],
  data() {
    return {
    }
  },
  created() {
  },
  updated() {
  },
  watch:{
  	open: function(){
  	},
  },
  methods: {
  }
};
</script>
<style>
</style>
